/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transfer_Dialog_Select_ProjectInputs */



/**
* | output |
* | --- |
* | "Select project..." |
*
* @param {Transfer_Dialog_Select_ProjectInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const transfer_dialog_select_project = /** @type {((inputs?: Transfer_Dialog_Select_ProjectInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transfer_Dialog_Select_ProjectInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt auswählen...")
	return /** @type {LocalizedString} */ ("Select project...")
});